import { createContext, useReducer, useContext } from "react";
import AnalyticsReducer from "../reducers/AnalyticsReducer";
import AnalyticsState from "../data/state/AnalyticsState";

const AnalyticsStateContext = createContext(AnalyticsState);
const AnalyticsDispatchContext = createContext(null);

function AnalyticsContextProvider({ children }) {
    const [state, dispatch] = useReducer(AnalyticsReducer, AnalyticsState);

    return (
        <AnalyticsStateContext.Provider value={state}>
            <AnalyticsDispatchContext.Provider value={dispatch}>{children}</AnalyticsDispatchContext.Provider>
        </AnalyticsStateContext.Provider>
    );
}

export default AnalyticsContextProvider;

export const useAnalyticsStateContext = () => useContext(AnalyticsStateContext);
export const useAnalyticsDispatchContext = () => useContext(AnalyticsDispatchContext);
